/**
 * 勤務が日をまたぐか（終了が翌日か）。
 *
 * **開始と終了を分で比べる。終了 ≦ 開始なら翌日。**
 *
 * 勤務表の3か所が、この1つを見る。
 *
 * - 勤務時間の計算（Roster.vue の dailyWorkResult）
 * - 終了時刻の24時超えの表記（Roster.vue の endSetting）
 * - 夜勤の枝分かれ（NightWork.vue）
 *
 * 以前は3か所が別々に判定していた。夜勤と24時超えの表記は「時」だけで比べ、勤務時間は
 * 開始を定時へ寄せたあとで比べていた。そのため、同じ時台の出退勤（09:10〜09:50）に夜勤 07:00 が付き、
 * 定時の開始までに退勤した日（08:40〜08:55）が翌日までの勤務（22:55）になっていた。
 *
 * @param startMinutes 開始。その日の 0:00 からの分（入力したままの時刻。定時へ寄せる前）
 * @param endMinutes   終了。その日の 0:00 からの分（24時超えの表記にする前の、入力したままの時刻）
 */
export const endsOnNextDay = (startMinutes, endMinutes) => endMinutes <= startMinutes
